// extracted by mini-css-extract-plugin
export default {"player":"nhRDy3","playerWrapper":"GJq9jn","overlay":"Dle5lv","hidden":"VJ3PRr","fillAllSpace":"WrXkTw"};